import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';

import { useAuthorizeBillit, useUser } from '~/api/user';
import { Spinner, Title } from '~/components';
import { SearchParamKeys } from '~/constants/url';
import { routes } from '~/providers/RouterProvider/router.routes';
import { toast } from '~/utils/toast';

import { loadingWrapperStyle, spinnerStyle } from './OauthBillit.css';

export const OauthBillit = () => {
  const { data: user } = useUser();
  const { mutate: authorizeBillit } = useAuthorizeBillit();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const code = searchParams.get(SearchParamKeys.BILLIT_CODE);

  const { t } = useTranslation(['common', 'settings']);

  useEffect(() => {
    if (!code || user.integrations.billit) {
      navigate(routes.settingsIntegrations, { replace: true });
      return;
    }

    authorizeBillit(code, {
      onSuccess: () => toast.success({ description: t('settings:alerts.integrations.successBillitPaired') }),
      onError: () => toast.danger({ description: t('common:error') }),
      onSettled: () => navigate(routes.settingsIntegrations, { replace: true }),
    });
  }, [authorizeBillit, code, navigate, t, user.integrations.billit]);

  return (
    <section className={loadingWrapperStyle}>
      <Spinner className={spinnerStyle} size={48} />

      <Title as="h4">{t('settings:integrations.processing')}</Title>
    </section>
  );
};
